<template>
  <div class="multisteps-form__panel border-radius-xl bg-white" data-animation="FadeIn">
    <h5 class="font-weight-bolder mb-0">{{ $t('location.Scrapie') }}</h5>
    <p class="mb-0 text-sm">{{ $t('location.Optional_information') }}</p>
    <div class="multisteps-form__content">
      <div class="row">
        <div class="col-12">
          <div class="row mt-4">
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Scrapie_certified') }}</label>                  
                <div class="d-block mt-1">
                  <material-switch v-model="localFormData.hasScrapieCertificate" id="hasScrapieCertificate" name="hasScrapieCertificate" />
                </div>
              </div>
            </div>               
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('location.Certificate_number') }}</label>
                <input v-model="localFormData.scrapieCertificateNumber" type="text" class="form-control form-control-default" :placeholder="$t('location.Certificate_number')">            
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="input-group input-group-static null" style="width: 150px;">
                <label class="">{{ $t('location.Issued_date') }}</label>
                <input v-model="localFormData.scrapieCertificateIssuedDate" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('location.Issued_date')">            
              </div>
            </div>
            <div class="col-6">
              <div class="input-group input-group-static null" style="width: 150px;">
                <label class="">{{ $t('location.Expiry_date') }} </label>
                <input v-model="localFormData.scrapieCertificateExpiryDate" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('location.Expiry_date')">            
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('location.Issued_by') }}</label>
                <input v-model="localFormData.scrapieIssuedBy" type="text" class="form-control form-control-default" :placeholder="$t('location.Issued_by')">            
              </div>
            </div>
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="">{{ $t('location.Verified_by') }} </label>
                <input v-model="localFormData.scrapieVerifiedBy" type="text" class="form-control form-control-default" :placeholder="$t('location.Verified_by')">            
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Upload_certificate') }}</label>
                <div class="d-block mt-1">
                  <input
                    type="file"               
                    accept=".pdf"
                    class=""
                    @change="handleFileUpload($event, 'scrapieCertificateFile')"
                  />
                  <span class="small" v-if="localFormData.scrapieCertificateFilePath">{{ localFormData.scrapieCertificateFilePath }}</span>           
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="input-group input-group-static null">
                <label class="d-block mb-1" style="width: inherit;">{{ $t('location.Certificate_verified') }}</label>                  
                <div class="d-block mt-1">
                  <material-switch v-model="localFormData.isScrapieCertificateVerified" id="isScrapieCertificateVerified" name="isScrapieCertificateVerified" />
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <label class="">{{ $t('location.Notes') }} </label>
              <textarea
                v-model="localFormData.scrapieNotes"
                class="form-control custom-textarea"
                style="border: 1px solid #ced4da;"
                rows="3"
              ></textarea>
            </div>        
          </div>      
        </div>
      </div>
      <div class="button-row d-flex mt-4">
        <button class="btn mb-0 bg-gradient-light btn-sm null null js-btn-prev" type="button" @click="this.$parent.prevStep">{{ $t('common.Prev') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
  
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import { reactive, watch } from 'vue'

export default {
  name: "CommentSection",
  props: {
    formData: Object
  },
  components: {      
    MaterialSwitch,
  },
  setup(props, { emit }) {
      const localFormData = reactive(props.formData);
      const todayDate = new Date().toISOString().split('T')[0];
      const handleFileUpload = (event, key) => {
        const file = event.target.files[0];
        if (file) {
          localFormData[`${key}Path`] = file.name; // For display
          localFormData[key] = file; // Store actual file for FormData
        }
      };

      watch(localFormData, () => {
        emit('update:formData', localFormData)
      }, { deep: true })

      return {
        localFormData,
        handleFileUpload,
        todayDate
      }
    } 
};
</script>
<style scoped>
.custom-textarea {
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 0.5rem;  
}
</style>